const userCredentialsKey = 'userCredentials';

const getUserCredentials = () => {
  const credentialsAsString = localStorage.getItem(userCredentialsKey);
  if (credentialsAsString) {
    return JSON.parse(credentialsAsString);
  }
  return;
};

const setUsersCredentials = (email, password) => {
  if (!email || !password) {
    return;
  }

  const credentialObject = { email, password };
  const credentialsAsString = JSON.stringify(credentialObject);
  localStorage.setItem(userCredentialsKey, credentialsAsString);
};

export { getUserCredentials, setUsersCredentials };
